import { Navigate, Route, Routes } from "react-router-dom";
import HomeContainer from "../ui/home/homeContainer";
import MainLayout from "./layouts/mainLayout";

/**
 * Rutas públicas del sitio institucional.
 *
 * Hoy el sitio es un one-page (Home). Para sumar páginas nuevas
 * (por ejemplo Blog o una landing por producto), agregá un <Route>
 * dentro del <MainLayout> con su container correspondiente en `ui/`.
 */
const PublicRoutes = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<HomeContainer />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
};

export default PublicRoutes;
